import { Helmet } from "react-helmet-async";
import Layout from "@/components/layout/Layout";
import Hero from "@/components/sections/Hero";
import ProblemSolution from "@/components/sections/ProblemSolution";
import ServicesPreview from "@/components/sections/ServicesPreview";
import Process from "@/components/sections/Process";
import MeetFounder from "@/components/sections/MeetFounder";
import BlogFeedSection from "@/components/sections/BlogFeedSection";
import ServiceAreasStrip from "@/components/sections/ServiceAreasStrip";
import IndustryLinksSection from "@/components/sections/IndustryLinksSection";

import SEOAuditWidget from "@/components/sections/SEOAuditWidget";
import CTABanner from "@/components/sections/CTABanner";
import ChatWidget from "@/components/ChatWidget";
import AuthorityProjectCollection from "@/components/authority/AuthorityProjectCollection";
import FeaturedPlatformsShowcase from "@/components/home/FeaturedPlatformsShowcase";
import PlatformVsTemplateComparison from "@/components/home/PlatformVsTemplateComparison";
import InvestmentTiers from "@/components/home/InvestmentTiers";
import { organization, organizationPostalAddress } from "@/config/organization";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": organization.organizationId,
  "name": organization.name,
  "legalName": organization.legalName,
  "url": organization.url,
  "logo": "https://valentinedigitalmarketing.com/logo-white.png",
  "description": "Full-service digital marketing agency helping Michigan businesses grow with SEO, PPC, web design, and custom business solutions.",
  "telephone": organization.phoneE164,
  "email": organization.email,
  "address": organizationPostalAddress,
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 43.6926,
    "longitude": -83.0318
  },
  "areaServed": [
    { "@type": "State", "name": "Michigan" },
    { "@type": "AdministrativeArea", "name": "Huron County" },
    { "@type": "AdministrativeArea", "name": "Tuscola County" },
    { "@type": "AdministrativeArea", "name": "Sanilac County" }
  ],
  "sameAs": organization.socialProfiles
};

const Index = () => {
  return (
    <Layout>
      <Helmet>
        <title>Valentine Digital Marketing | Michigan's Premier Digital Agency</title>
        <meta name="description" content="Valentine Digital is a Michigan-based digital agency providing SEO, paid advertising, web design, and custom business solutions." />
        <link rel="canonical" href="https://valentinedigitalmarketing.com" />
        <meta property="og:title" content="Valentine Digital Marketing | Michigan's Premier Digital Agency" />
        <meta property="og:description" content="Full-service digital marketing agency helping Michigan businesses grow. SEO, PPC, web design, and custom solutions." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://valentinedigitalmarketing.com" />
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <Hero />
      <ProblemSolution />
      <ServicesPreview />
      <FeaturedPlatformsShowcase />
      <PlatformVsTemplateComparison />
      <InvestmentTiers />
      <AuthorityProjectCollection type="latest" heading="Recent client wins" limit={3} />
      <Process />
      <MeetFounder />
      <IndustryLinksSection />
      <ServiceAreasStrip />
      <BlogFeedSection
        title="Latest Insights"
        subtitle="Expert tips and strategies to grow your Michigan business"
        showFeatured
        limit={3}
        ctaLink="/blog"
        ctaText="View All Articles"
      />
      
      <SEOAuditWidget />
      <CTABanner />
      <ChatWidget />
    </Layout>
  );
};

export default Index;
